function printDiv(divClassName){
            var printContents = $('.woocommerce').html();
            var originalContents = document.body.innerHTML;

            document.body.innerHTML = printContents;
            window.print();
            document.body.innerHTML = originalContents;
}
